export const  StockItemCategoryColumns = [
    "SNo",
    "Category",
    "Type"
   
];
